'use client';

import { useGlobalInfo } from '@/app/contexts/GlobalInfoContext';

import { useLayoutEffect } from 'react';

interface PageContextUpdaterProps {
  title: string;
  description: string;
  hideBackButton?: boolean;
}

/**
 * Este componente se utiliza para actualizar el contexto global de la página.
 * Recibe un título, una descripción y un booleano para ocultar el botón de retroceso.
 * Estos valores se utilizan para actualizar el estado del contexto global.
 * No renderiza ningún elemento en el DOM.
 *
 * @param {PageContextUpdaterProps} props - Las propiedades del componente.
 *
 * @param {string} props.title - El título de la página.
 *
 * @param {string} props.description - La descripción de la página.
 *
 * @param {boolean} [props.hideBackButton] - Si es verdadero, oculta el botón de retroceso.
 *
 * @returns {null} No renderiza nada.
 */
export function PageContextUpdater({
  title,
  description,
  hideBackButton
}: PageContextUpdaterProps) {
  const { setGlobalInfo } = useGlobalInfo();

  useLayoutEffect(() => {
    setGlobalInfo(() => ({
      title,
      description,
      hideBackButton: hideBackButton !== undefined ? hideBackButton : false
    }));
  }, [title, description, hideBackButton, setGlobalInfo]);

  return null;
}
